import React, { useEffect, useState } from "react";
import Page from "../../../components/Page";
import { makeStyles } from "tss-react/mui";
import { useLocation } from "react-router-dom";
import NewPIDEntry from "./NewPIDEntry/NewPIDEntry";
import PIDFile from "./PIDFile/PIDFile";
import { getFile } from "../../../core/repo/fileRepo";
import { useDispatch } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
  },
}));

function PIDMainView() {
  const { classes } = useStyles();
  const [pidFile, setPidFile] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pidFileId = queryParams.get("fileId");
  const tabId = queryParams.get("tabId");

  async function fetchPidFile() {
    try {
      const response = await dispatch(getFile(pidFileId));
      setPidFile(response);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    fetchPidFile();
    // if (pidFileId) {
    //   setPidFile({
    //     pid_url:
    //       "https://text-dataset.s3.ap-south-1.amazonaws.com/1T4031-PR-5AE.9.-.9.01.jpg",
    //     annotations: [],
    //   });
    // }
  }, [pidFileId]);

  return (
    <Page className={classes.root} title={"PID"}>
      {pidFileId && pidFile ? <PIDFile pidFile={pidFile} /> : <NewPIDEntry />}
    </Page>
  );
}

export default PIDMainView;
